import React from 'react'
import { Typography, Link } from '@mui/material'
import { Colors } from '../../styles/theme'
import { appUtilities } from '../../utilities/appUtilities.js'

function privacyLink(text, path, label) {
    return (
        <Link
            href={path}
            color={Colors.secondary}
            variant="body1"
            sx={{ fontWeight: 600 }}
            // underline="none"
            aria-label={label}
        >
            {text}
        </Link>
    )
}

export default function CardSecurity() {
    const regTM = appUtilities.regTrademark
    const auth1 = `You can shop at ElectroBraid`
    const auth1b = ` Fence with confidence. We have
  partnered with`
    const auth2 = privacyLink(
        `Moneris,`,
        `https://www.moneris.com/`,
        `Visit Moneris the payment gateway`,
    )

    const auth3 = ``

    const auth5 = ` a major payment processor established in 2000 by RBC, to safely and securely accept credit card payments for our customers. Moneris processes more than three billion transactions a year for hundreds of thousands of merchant locations. The Moneris Gateway executes the secure transmission, authorization, and settlement of payment data across all major credit networks. The company adheres to strict industry standards for payment processing, including:`
    const auth5b = (
        <Typography sx={{ ml: 6, mt: 2, mb: 2 }}>
            <Typography sx={{ mt: 1 }}>
                - TLS encryption (TLS 1.2 / 1.3) for all transactions
                transmitted between your browser, our checkout, and the Moneris
                Gateway.
            </Typography>
            <Typography sx={{ mt: 1 }}>
                - PCI DSS Level 1 certification — the highest level of
                compliance defined by the Payment Card Industry Security
                Standards Council — covering Moneris&rsquo;s processing
                infrastructure and the Moneris Gateway application.
            </Typography>

            <Typography sx={{ mt: 1 }}>
                - Advanced Encryption and Tokenization: Modern cryptographic
                protocols that protect sensitive information during
                transmission, ensuring your data cannot be intercepted or
                reused.
            </Typography>
        </Typography>
    )

    const auth5c = ` For additional information regarding the privacy of your
    sensitive cardholder data, please read the `
    const auth6 = privacyLink(
        `Moneris Privacy Statement.`,
        `https://www.moneris.com/en/legal/privacy-statement`,
        `Visit the Moneris Privacy Statement`,
    )

    const auth6b = ` For details on Moneris's PCI compliance program, see the `

    const auth7 = privacyLink(
        `Moneris PCI Data Security`,
        `https://www.moneris.com/en/support/compliance-and-security/pci-data-security`,
        `Visit Moneris PCI Data Security`,
    )

    const auth8 = ` page.  Our store at`

    const auth8a = privacyLink(
        `https://electrobraid.com`,
        `https://electrobraid.com/`,
        `Visit ElectroBraid Fence`,
    )
    const auth9 = `processes all credit card transactions through the Moneris secure payment gateway.
`

    const auth = [
        auth1,
        regTM,
        auth1b,
        auth2,
        auth3,
        auth5,
        auth5b,
        auth5c,
        auth6,
        auth6b,
        auth7,
        auth8,
        auth8a,
        auth9,
    ]
    const foxy1 = `In order to minimize the risk of security incidents, ElectroBraid`

    const foxy1b = ` Fence fully
    outsources all payment processing to `

    const foxy2 = privacyLink(
        'Foxy.io',
        'https://www.foxy.io/',
        ' Visit Ecommerce platform Foxy.io',
    )

    const foxy3 = `. Foxy.io is PCI DSS (Payment Card Industry Data Security Standard) Compliant and as a Level 1 Service Provider is listed on both Visa and MasterCard's global registries. Anytime you submit payment
    information via ElectroBraid`

    const foxy4 = ` Fence's website, you are submitting through
    Foxy.io's secure infrastructure. ElectroBraid`

    const foxy5 = ` Fence retains only the last 4 digits, the card type, and the expiration date of your payment details.`

    const foxy = [
        foxy1,
        regTM,
        foxy1b,
        foxy2,
        foxy3,
        regTM,
        foxy4,
        regTM,
        foxy5,
    ]

    return (
        <>
            <Typography variant="h4" sx={{ mt: 3 }}>
                Credit Cardholder Data Security
            </Typography>

            <Typography variant="h6" sx={{ mt: 2 }}>
                Credit Card Payment Gateway - Moneris
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    ml: { xs: 0, sm: 2, md: 8 },
                    mr: { xs: 1, sm: 5, md: 20 },
                    mt: 2,
                }}
            >
                {auth}
            </Typography>
            <Typography variant="h6" sx={{ mt: 4 }}>
                Ecommerce Platform - FoxyCart
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    ml: { xs: 0, sm: 2, md: 8 },
                    mr: { xs: 1, sm: 5, md: 20 },
                    mt: 2,
                }}
            >
                {foxy}
            </Typography>
        </>
    )
}
